import script from "./Management.vue?vue&type=script&setup=true&lang=js"
export * from "./Management.vue?vue&type=script&setup=true&lang=js"

import "./Management.vue?vue&type=style&index=0&id=f0e8d16a&lang=scss&scoped=true"

import exportComponent from "K:\\宫俊勇\\青桔pc官网wf-qjgw\\wf-qjgw\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0e8d16a"]])

export default __exports__